import { Intervention } from '@agroone/entities'
import { DatePipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core'
import { TranslatePipe, TranslateService } from '@ngx-translate/core'
import { TranslateConstantPipe } from '../../../../pipes'
import { SharedConstantService, SharedUserService } from '../../../../services'
import { InterventionFoodSafetyTypes } from '../../enums/intervention-foodsafety-types.enum'
import { NutrientsActivityTypePipe } from '../../pipes/nutrients-activity-type.pipe'

@Component({
  selector: 'irrigation',
  templateUrl: './irrigation.component.html',
  styleUrls: ['./irrigation.component.scss'],
  imports: [TranslateConstantPipe, TranslatePipe, DatePipe, NutrientsActivityTypePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class IrrigationComponent {
  readonly intervention = input.required<Intervention>()
  public constantService: SharedConstantService = inject(SharedConstantService)
  public translate: TranslateService = inject(TranslateService)
  public userService: SharedUserService = inject(SharedUserService)
  public interventionFoodSafetyTypes = InterventionFoodSafetyTypes

  get nutrients() {
    const nutrients = this.intervention().irrigation?.nutrients ?? []

    return nutrients.map((n) => ({
      nutrient: n.nutrient,
      value: n.value,
    }))
  }
}
